// @ts-nocheck
import React, { useMemo } from 'react';
import intl from 'react-intl-universal';
import {
  Button,
  ButtonGroup,
  Intent,
  Menu,
  MenuDivider,
  MenuItem,
} from '@blueprintjs/core';
import { Icon } from '@/components';
import { safeCallback } from '@/utils';

/**
 * Row actions menu list.
 */
export function ActionMenuList({
  row: { original },
  payload: { onEditCarrier, onDeleteCarrier },
}) {
  return (
    <Menu>
      <MenuItem
        icon={<Icon icon="pen-18" />}
        text={intl.get('edit_carrier')}
        onClick={safeCallback(onEditCarrier, original)}
      />
      <MenuDivider />
      <MenuItem
        icon={<Icon icon="trash-16" iconSize={16} />}
        text={intl.get('delete_carrier')}
        onClick={safeCallback(onDeleteCarrier, original)}
        intent={Intent.DANGER}
      />
    </Menu>
  );
}

/**
 * Actions cell.
 */
function ActionsCell({
  row: { original },
  payload: { onEditCarrier, onDeleteCarrier },
}) {
  return (
    <ButtonGroup minimal={true}>
      <Button
        icon={<Icon icon="pen-18" iconSize={13} />}
        iconSize={14}
        className="m12"
        minimal={true}
        onClick={safeCallback(onEditCarrier, original)}
        style={{ marginRight: '5px', background: 'none'}}
      />
      <Button
        intent={Intent.DANGER}
        icon={<Icon icon="trash" iconSize={13} />}
        iconSize={14}
        className="m12"
        minimal={true}
        onClick={safeCallback(onDeleteCarrier, original)}
        style={{ background: 'none' }}
      />
    </ButtonGroup>
  );
}

/**
 * Carriers table columns hook.
 */
export function useCarriersTableColumns() {
  return useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        width: 140,
      },
      {
        Header: 'Carrier Codes Description',
        accessor: 'description',
        className: 'description',
        width: 240,
        textOverview: true,
      },
      {
        Header: 'Url',
        accessor: 'url',
        className: 'url',
        width: 180,
        textOverview: true,
      },
       {
        id: 'actions',
        Header: 'Actions',
        Cell: ActionsCell,
        className: 'actions',
        width: 100,
        disableResizing: true,
      },
    ],
    [],
  );
}
